import { createStyles } from 'antd-style';

import {
  ThemeColors,
  ThemeFont,
  ThemeSpaces,
  hexToRgbaWithAlpha,
} from '../../../../theme';

export const useAdminAccountProfileCardStyles = createStyles(({ token }) => ({
  card: {
    // AccountBusinessTypeField / AdminConsoleSection are shared building
    // blocks used across the whole admin console; this only overrides their
    // look when they render inside an account profile-style card.
    '.AdminAccountDetail__HeaderRight, .AdminAccountDetail__HeaderRight .ant-btn.AdminConsole__ButtonDropdownTrigger':
      {
        fontFamily: ThemeFont.FONT_CONDENSED,
        fontWeight: token.fontWeightStrong,
        fontSize: token.fontSizeLG,
        color: token.colorWhite,
      },

    '.AdminConsoleSection--Level0, .AdminConsoleSection--Level1': {
      backgroundColor: ThemeColors.COLOR_WHITE2,
      boxShadow: `0 1px 10px 0 ${hexToRgbaWithAlpha(
        ThemeColors.COLOR_GREY_BLUISH,
        0.35
      )}`,
    },

    '.AdminConsoleSection__Header': {
      backgroundColor: ThemeColors.COLOR_GREY_BLUISH,

      '&--Level1': {
        backgroundColor: ThemeColors.COLOR_GREY9_9,
        border: `1px solid ${ThemeColors.COLOR_WHITE2}`,

        '> strong': {
          color: ThemeColors.COLOR_GREY_BLUISH,
        },
      },
    },
  },
  titleRow: {
    padding: `${ThemeSpaces.SPACE_NORM}px 0`,
  },
  title: {
    display: 'flex',
    alignItems: 'center',
    gap: ThemeSpaces.SPACE_NORM,
    fontFamily: ThemeFont.FONT_CONDENSED,
    fontWeight: token.fontWeightStrong,
    fontSize: 18,
    color: ThemeColors.COLOR_GREY11,
  },
  accountLabel: {
    fontWeight: 400,
    fontSize: 24,
    color: token.colorWhite,
  },
}));
